module.exports = __webpack_public_path__ + "static/img/xcx.bea99b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xcx.png
// module id = 710
// module chunks = 1